import { BooleanInput, Create, ImageField, ImageInput, required, SimpleForm, TextInput } from "react-admin";

const ChannelCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <TextInput label="Title" isRequired source="name" validate={required()} />
        <TextInput source="subtitle" />
        <ImageInput source="image">
          <ImageField source="src" />
        </ImageInput>
        {/* NOTE: disabled for now, need a way to add users manually */}
        <BooleanInput source="addUsersAutomatically" defaultValue={true} disabled />
      </SimpleForm>
    </Create>
  );
};

export default ChannelCreate;
